import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, isNotEmpty } from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class AddsDTO {

  @ApiProperty()
  @ApiPropertyOptional()
  Id?: number;
  @ApiProperty()
  @ApiPropertyOptional()
  imagePath?:string;
  @ApiProperty({ type: 'array', items: { type: 'string', format: 'binary' } })
  image:string;
  @ApiProperty()
  @IsNotEmpty({message:" Redirect URL should not be empty"})
  redirectUrl:string;
  @ApiProperty()
  @IsNotEmpty({message:"Location should not be empty"})
  location:string;
  @ApiProperty()
  isHome:number;
  @ApiProperty()
  @ApiPropertyOptional()
  status: boolean;
  createdAt : Date;
  @ApiProperty()
  @ApiPropertyOptional()
  createdUser : number;
  updatedAt : Date;
  @ApiProperty()
  @ApiPropertyOptional()
  updatedUser : number;
  @ApiProperty()
  @ApiPropertyOptional()
  versionFlag : number;
}

